import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { AxiosError, AxiosRequestConfig } from 'axios';
import customAxios from 'lib/axios';

type Args = {
  url: string;
  method?: AxiosRequestConfig['method'];
  params?: AxiosRequestConfig['params'];
  data?: AxiosRequestConfig['data'];
  headers?: AxiosRequestConfig['headers'];
  // RTKQ pasa AbortController.signal: ¡Axios v1 lo soporta!
  signal?: AbortSignal;
  // Para blobs / etc:
  responseType?: AxiosRequestConfig['responseType'];
};

export const axiosBaseQuery =
  (): BaseQueryFn<Args, unknown, unknown> =>
  async ({ url, method = 'GET', params, data, headers, signal, responseType }) => {
    try {
      const res = await customAxios.request({
        url, method, params, data, headers, signal, responseType,
      });
      return { data: res.data };
    } catch (e) {
      const err = e as AxiosError<any>;
      return {
        error: {
          status: err.response?.status ?? 'FETCH_ERROR',
          data: err.response?.data ?? err.message,
        },
      };
    }
  };
